/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-29 15:43:45
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 11:01:17
 */
import { ExclamationCircleOutlined } from "@ant-design/icons"
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Space,
} from "antd"
import TextArea from "antd/lib/input/TextArea"
import _ from "lodash"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { ThemeContext } from "../../../theme/ThemeContext"
import {
  getPrinters,
  getPrintTemplateSettingUserList,
  initializePrintService,
  selectPrintServiceState,
} from "../../print/printSlice"
import styles from "../PrintSettingAll.module.css"
import txmImg from "../assets/blhIcon.png"
import { selectTenantName } from "../../../app/applicationSlice"
import { getGenderName } from "../../../models/user"
import {
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
} from "../../../models/datetime"
import {
  getPrintInitOneConfigAsync,
  getPrintRestoreConfigDefaultAsync,
  getPrintSettingDetailAsync,
  getPrintSettingEditOrYLAsync,
  getPrintSettingSubmitAsync,
  getPrintSettingsyncTenantNameAsync,
} from "../PrintSettingAllSlice"
import { pinyin } from "pinyin-pro"
import { LoadingState } from "../../../models/common"

export const OthersPrintSetting = (props: {
  selectKey?: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const tenantName = useSelector(selectTenantName)

  const [selectButtonId, setSelectButtonId] = useState<any>("1")

  const [users, setUsers] = useState<any>([])

  const [elseUsers, setElseUsers] = useState<any>([])

  const [nurses, setNurses] = useState<any>([])

  const [detail, setDetail] = useState<any>()

  const [isMask, setIsMask] = useState(true)

  const [changeData, setChangeData] = useState<any>()

  const [buttonLoading, setButtonLoading] = useState(false)

  const initialized = useSelector(selectPrintServiceState)

  const [showAcceptanceUserTypeListFlag, setAcceptanceUserTypeListFlag] = useState(
    false
  ) //是否展示验收人员标志位

  const [acceptanceUserSignType, setAcceptanceUserSignType] = useState(false) //验收人

  const diagnosisMessage = {
    treatmentDate: "20250909",
    patientName: "陈越新",
    patientSex: '男',
    patientAge: '37岁',
    patientId: 109283076,
    address: '浙江省杭州市滨江区三维大厦C座603',
    companyAddress: '杭州市西湖区文三路90号东部软件园',
    disease: '上呼吸道感染',
    view: '以抗炎、清瘟解毒、宜肺泄热对症治疗。如无好转，请随时转升上级医院就诊。建议休息一天',
    printTime: '2025/09/09 08:45:08'
  }

  const recipeTypeList = [{ name: "诊断证明书", id: "1" }]

  const title = (name: any) => {
    return (
      <div className={styles.titleContent}>
        <div className={styles.title}>{name}</div>
      </div>
    )
  }

  const getRecipeTitleText = (flag: any) => {
    switch (flag) {
      case "1":
        return "诊断证明书"
    }
  }

  useEffect(() => {

    // 获取正常的
    dispatch(getPrintTemplateSettingUserList({ stationType: 3 }))
      .then(unwrapResult)
      .then((users: any) => {
        setElseUsers(users)
      })
      .catch(() => {
        // do nothing.
      })
  }, [])

  useEffect(() => {
    if (initialized === LoadingState.Idle) {
      dispatch(initializePrintService())
        .then(unwrapResult)
        .catch(() => {
          // do nothing.
        })
    }
    if (initialized === LoadingState.Finished) {
      dispatch(getPrinters())
    }
  }, [dispatch, initialized])

  useEffect(() => {
    if (props?.selectKey == "6") {
      getDetail()
    }
  }, [props?.selectKey, selectButtonId])

  const getDetail = () => {
    const id =
      selectButtonId == "1"
        ? "DiagnosisCertificate"
        : ""
    dispatch(getPrintSettingDetailAsync({ templateCode: id }))
      .then(unwrapResult)
      .then((v: any) => {
        if (JSON.stringify(v) === "{}") {
          setIsMask(true)
          return
        } else {
          setIsMask(false)
        }
        setDetail(v)
        const headerMain: any = {
          direction: v?.globalConfig?.direction,
          paperSizeUnlimited: v?.globalConfig?.paperSizeUnlimited,
          topMargin: v?.globalConfig?.topMargin,
          leftMargin: v?.globalConfig?.leftMargin,
          font: v?.globalConfig?.font,
        }
        const titlePatientMessage: any ={
          titleName: v?.headerConfig?.titleName,
          treatmentId: v?.headerConfig?.treatmentId,
          treatmentDate: v?.headerConfig?.treatmentDate,
        }
        const contentMessage: any =
          selectButtonId == "1"
            ? {
                patientName: v?.bodyConfig?.first_line?.patientName,
                patientSex: v?.bodyConfig?.first_line?.patientSex,
                patientAge: v?.bodyConfig?.first_line?.patientAge,
                patientId: v?.bodyConfig?.first_line?.patientId,
                address: v?.bodyConfig?.second_line?.address,
                disease: v?.bodyConfig?.second_line?.disease,
                view: v?.bodyConfig?.second_line?.view,
                patientAddressUseCompanyName: v?.bodyConfig?.second_line?.patientAddressUseCompanyName,
              }
            : {}

        const bottomMessage: any = {
          show: v?.footerConfig?.show,
          content: v?.footerConfig?.content,
          printTime: v?.footerConfig?.printTime,
        }
        form.setFieldsValue({
          ...headerMain,
          ...titlePatientMessage,
          ...contentMessage,
          ...bottomMessage,
        })

        const changeDatas = {
          ...titlePatientMessage,
          ...contentMessage,
          ...bottomMessage,
        }
        setChangeData({ ...changeDatas, font: v?.globalConfig?.font })
      })
  }
  return (
    <div className={styles.container}>
      {isMask ? (
        <div className={styles.containerMask}>
          <span>新版模板：支持个性化编辑</span>
          <Button
            onClick={() => {
              const id =
                selectButtonId == "1"
                  ? "DiagnosisCertificate"
                  : ""
              dispatch(getPrintInitOneConfigAsync({ templateCode: id }))
                .then(unwrapResult)
                .then(() => {
                  getDetail()
                })
            }}
            style={{
              background: "#027AFF",
              color: "#FFFFFF",
              width: 120,
              height: 40,
              lineHeight: "30px",
            }}
          >
            开启模板
          </Button>
        </div>
      ) : (
        <></>
      )}
      <Row className={styles.recipePrintContent}>
        <Col className={styles.leftContent}>
          <Col span={24} className={styles.recipeTypeButtonMain}>
            {recipeTypeList?.map((v: any) => {
              return (
                <Button
                  key={v?.id}
                  type={v?.id == selectButtonId ? "primary" : "ghost"}
                  style={{ marginLeft: "8px" }}
                  onClick={() => {
                    setSelectButtonId(v?.id)
                    setChangeData({})
                  }}
                >
                  {v?.name}
                </Button>
              )
            })}
          </Col>
          <div className={styles.leftBottomFormContent}>
            <Form
              form={form}
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              autoComplete="off"
              onFinish={(values: any) => {
                if (values?.acceptanceUserType == 1 && !values?.acceptanceUserId) {
                  notification.info({
                    message: "请选择固定验收人",
                  })
                  return
                }
                const params: any =
                  selectButtonId == "1"
                    ? {
                        id: detail?.id,
                        templateId: detail?.templateId,
                        globalConfig: {
                          direction: values?.direction,
                          topMargin: Number(values?.topMargin),
                          leftMargin: Number(values?.leftMargin),
                          paperSizeUnlimited: values?.paperSizeUnlimited,
                          font: values?.font,
                        },
                        headerConfig: {
                          titleName: values?.titleName,
                          treatmentId: values?.treatmentId,
                          treatmentDate: values?.treatmentDate,
                        },
                        bodyConfig: {
                          first_line: {
                            patientName: values?.patientName,
                            patientSex: values?.patientSex,
                            patientAge: values?.patientAge,
                            patientId: values?.patientId,
                          },
                          second_line: {
                            address: values?.address,
                            disease: values?.disease,
                            view: values?.view,
                            patientAddressUseCompanyName: values?.patientAddressUseCompanyName,
                          },
                        },
                        footerConfig: {
                          show: values?.show,
                          content: values?.content,
                          printTime: values?.printTime,
                        },
                      }
                    : {}
                setButtonLoading(true)
                dispatch(getPrintSettingSubmitAsync(params))
                  .then(unwrapResult)
                  .then((v: any) => {
                    setButtonLoading(false)
                    notification.success({
                      message: "操作成功",
                    })
                    getDetail()
                  })
              }}
            >
              {title("全局信息")}
              <Row className={styles.rowHeight}>
                <Col span={24}>
                  <Form.Item label="纸张进入方向" name="direction">
                    <Radio.Group
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <Col span={5}>
                        <Radio value={0}>横版</Radio>
                      </Col>
                      <Col span={19} style={{ position: "relative" }}>
                        <Radio value={1}>竖版</Radio>
                      </Col>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row className={styles.rowHeight}>
                <Col span={24}>
                  <Form.Item
                    label={"限制纸张大小"}
                    name="paperSizeUnlimited"
                    valuePropName="checked"
                  >
                    <Checkbox>开启</Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              <Row className={styles.rowHeight}>
                <Col span={4}>偏移量</Col>
                <Col span={10}>
                  <Row className={styles.alignItemsCenter}>
                    上偏移量
                    <Form.Item label="" name="topMargin">
                      <Input
                        type="number"
                        style={{ width: "90px", marginLeft: "10px" }}
                      />
                    </Form.Item>
                    （毫米）
                  </Row>
                </Col>
                <Col span={10}>
                  <Row className={styles.alignItemsCenter}>
                    左偏移量
                    <Form.Item label="" name="leftMargin">
                      <Input
                        type="number"
                        style={{ width: "90px", marginLeft: "10px" }}
                      />
                    </Form.Item>
                    （毫米）
                  </Row>
                </Col>
              </Row>
              <Row className={styles.rowHeight}>
                <Col span={24}>
                  <Form.Item label='字体' name='font'>
                    <Radio.Group
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                      }}
                      onChange={(e) => {
                        setChangeData({
                          ...changeData,
                          font: e.target?.value
                        })
                      }}
                    >
                      <Col span={5}>
                        <Radio value={0} >
                          黑体 
                        </Radio>
                      </Col>
                      <Col span={19}>
                        <Radio value={1}>
                          宋体 
                        </Radio>
                      </Col>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
              {title("头部信息")}
              <Row className={styles.rowHeight}>
                <Col span={4}>抬头名称</Col>
                <Col span={20}>
                  <Row className={styles.alignItemsCenter}>
                    <Form.Item label="" name="titleName">
                      <Input
                        style={{ width: "380px" }}
                        suffix={getRecipeTitleText(selectButtonId)}
                        onChange={(e) => {
                          setChangeData({
                            ...changeData,
                            titleName: e?.target?.value,
                          })
                        }}
                      />
                    </Form.Item>
                    <span
                      className={styles.nameTips}
                      onClick={() => {
                        dispatch(
                          getPrintSettingsyncTenantNameAsync({
                            tenantName: changeData?.titleName,
                          })
                        )
                          .then(unwrapResult)
                          .then((v) => {
                            notification.success({
                              message: "操作成功",
                            })
                          })
                      }}
                    >
                      运用至全部
                    </span>
                  </Row>
                </Col>
              </Row>
              {selectButtonId == "1" && (
                <Row className={styles.radioWidth6}>
                  <Col span={4} style={{ marginTop: "8px" }}>
                    抬头信息
                  </Col>
                  <Col span={20}>
                    <Row>
                      <Col span={6}>
                        <Form.Item name="treatmentId" valuePropName="checked">
                          <Checkbox
                            onChange={(e) => {
                              setChangeData({
                                ...changeData,
                                treatmentId: e?.target?.checked,
                              })
                            }}
                          >
                            就诊条码
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          name="treatmentDate"
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e) => {
                              setChangeData({
                                ...changeData,
                                treatmentDate: e?.target?.checked,
                              })
                            }}
                          >
                            诊断日期
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {title("正文")}
              {
                // 诊断证明书
                selectButtonId == "1" ? (
                  <>
                    <Row className={styles.radioWidth6}>
                      <Col span={4} style={{ marginTop: "8px" }}>
                        明细内容
                      </Col>
                      <Col span={20}>
                        <Row>
                          <Col span={6}>
                            <Form.Item name="patientName" valuePropName="checked">
                              <Checkbox disabled>
                                姓名
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item name="patientSex" valuePropName="checked">
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    patientSex: e?.target?.checked,
                                  })
                                }}
                              >
                                性别
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="patientAge"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    patientAge: e?.target?.checked,
                                  })
                                }}
                              >
                                年龄
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="patientId"
                              valuePropName="checked"
                            >
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    patientId: e?.target?.checked,
                                  })
                                }}
                              >
                                病历号
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={6}>
                            <Form.Item name="address" valuePropName="checked">
                              <Checkbox
                                onChange={(e: any) => {
                                  setChangeData({
                                    ...changeData,
                                    address: e?.target?.checked,
                                  })
                                }}
                              >
                                地址
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="disease"
                              valuePropName="checked"
                            >
                              <Checkbox disabled>
                                诊断
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Form.Item
                              name="view"
                              valuePropName="checked"
                            >
                              <Checkbox disabled>
                                意见
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                {changeData?.address && (
                  <Row className={styles.rowAreaHeight}>
                    <Col span={4} style={{ marginTop: '8px' }}>
                      地址显示
                    </Col>
                    <Col span={20}>
                      <Form.Item
                        name='patientAddressUseCompanyName'
                        valuePropName='checked'
                      >
                        <Checkbox 
                          style={{ width: '300px' }}
                          onChange={(e) => {
                            setChangeData({
                              ...changeData,
                              patientAddressUseCompanyName: e.target?.checked,
                            })
                          }}
                        >
                          医保患者地址显示工作单位
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                )}
                  </>
                ) : (
                  <></>
                )
              }

              {title("尾部信息")}

              <>
                <Row className={styles.radioWidth12}>
                  <Col span={4} style={{ marginTop: "8px" }}>
                    尾部备注
                  </Col>
                  <Col span={20}>
                    <Row className={styles.alignItemsCenter}>
                      <Col span={24}>
                        <Form.Item
                          label=''
                          name='show'
                          valuePropName='checked'
                        >
                          <Checkbox
                            onChange={(v) => {
                              setChangeData({
                                ...changeData,
                                show: v?.target?.checked,
                              })
                            }}
                          >
                            展示
                          </Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label='' name='content'>
                          <TextArea
                            maxLength={20}
                            showCount
                            onChange={(v) => {
                              setChangeData({
                                ...changeData,
                                content: v?.target?.value,
                              })
                            }}
                          ></TextArea>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className={styles.rowHeight}>
                    <Col span={24}>
                    <Form.Item
                        label={"尾部信息"}
                        name="printTime"
                        valuePropName="checked"
                    >
                        <Checkbox
                            onChange={(e) => {
                                setChangeData({
                                    ...changeData,
                                    printTime: e.target?.checked,
                                })
                            }}
                        >打印时间</Checkbox>
                    </Form.Item>
                    </Col>
                </Row>
              </>

              <Row
                style={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "30px 0",
                  position: "fixed",
                  bottom: 0,
                  left: "29%",
                }}
              >
                <Button
                  ghost
                  loading={buttonLoading}
                  style={{
                    color: "#101010",
                    border: "1px solid #BBBBBB",
                    marginRight: "10px",
                  }}
                  onClick={() => {
                    Modal.confirm({
                      centered: true,
                      title: "",
                      content: <div>是否确认恢复系统默认？</div>,
                      okText: "确认",
                      cancelText: "取消",
                      icon: null,
                      onOk: () => {
                        const id = selectButtonId == "1" ? "DiagnosisCertificate" : ""
                        dispatch(
                          getPrintRestoreConfigDefaultAsync({
                            templateCode: id,
                          })
                        )
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: "操作成功",
                            })
                            getDetail()
                          })
                      },
                    })
                  }}
                >
                  恢复系统默认
                </Button>
                <Button
                  loading={buttonLoading}
                  style={{ background: "#027AFF", color: "#FFFFFF" }}
                  htmlType="submit"
                >
                  保存
                </Button>
              </Row>
            </Form>
          </div>
        </Col>
        <Col className={`${styles.rightContent} ${changeData?.font == 1 ? styles.fontSong : styles.fontHei}`} style={{ width: "700px" }}>
          <div className={styles.rightContentTitle}>
            <span>{getRecipeTitleText(selectButtonId)}</span>
            <div className={styles.titleButton}>
              <Button
                type={"primary"}
                style={{ marginRight: "8px" }}
                onClick={async () => {
                  const params =
                    selectButtonId == "1"
                      ? { templateCode: "DiagnosisCertificate", setupFlag: true }
                      : {}
                  await dispatch(getPrintSettingEditOrYLAsync(params))
                }}
              >
                编辑
              </Button>
              <Button
                type={"primary"}
                style={{ marginRight: "8px" }}
                onClick={async () => {
                  const params =
                    selectButtonId == "1"
                      ? { templateCode: "DiagnosisCertificate", setupFlag: false }
                      : {}
                  await dispatch(getPrintSettingEditOrYLAsync(params))
                }}
              >
                打印效果
              </Button>
            </div>
          </div>
          <div className={styles.rightContentMain}>
            {/* 机构名 */}
            <div className={styles.tenantNameTitle}>
              {changeData?.titleName}
            </div>

            {/* 头部信息 */}
            <div className={styles.subTitleMain}>
              <Col span={5} className={styles.subTitleMainLeft}>
                {changeData?.treatmentId && <div className={styles.subTitleMainLeftTop}>
                  {(
                    <div style={{ height: '38px' }}>
                      <img src={txmImg}></img>
                      <div>130284332</div>
                    </div>
                  )}
                </div>}
              </Col>
              <Col span={14} className={styles.subTitleMainCenter}>
                {getRecipeTitleText(selectButtonId)}
              </Col>
              <Col span={5} className={styles.subTitleMainRight} style={{ marginTop: 19 }}>
                {changeData?.treatmentDate && (
                  <>
                    <div className={styles.titleFourTextStyle}>诊断日期：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {diagnosisMessage?.treatmentDate}
                    </div>
                  </>
                )}
              </Col>
            </div>

            {/* 诊断证明书*/}
            <div className={styles.diagnosisContent}>
              <div className={styles.diagnosisContentTop}>
                <Row>
                  <Col span={6} className={styles.TextStyle}>
                    <div className={styles.titleTwoTextStyle}>姓名：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {diagnosisMessage?.patientName}
                    </div>
                  </Col>
                  {changeData?.patientSex && (
                    <Col span={6} className={styles.TextStyle}>
                      <div className={styles.titleTwoTextStyle}>性别：</div>
                      <div
                        className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                      >
                        {diagnosisMessage?.patientSex}
                      </div>
                    </Col>
                  )}
                  {changeData?.patientAge && (
                    <Col span={6} className={styles.TextStyle}>
                      <div className={styles.titleTwoTextStyle}>年龄：</div>
                      <div
                        className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                      >
                        {diagnosisMessage?.patientAge}
                      </div>
                    </Col>
                  )}
                  {changeData?.patientId && (
                    <Col span={6} className={styles.TextStyle}>
                      <div className={styles.titleThreeTextStyle}>病历号：</div>
                      <div
                        className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                      >
                        {diagnosisMessage?.patientId}
                      </div>
                    </Col>
                  )}
                </Row>
                <Row style={{ paddingTop: 10 }}>
                  {changeData?.address && (
                    <Col span={24} className={styles.TextStyle}>
                      <div className={styles.titleTwoTextStyle}>地址：</div>
                      <div
                        className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                      >
                      {diagnosisMessage?.address}
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
              <div className={styles.diagnosisContentCenter}>
                <Row>
                  <Col span={24} className={styles.TextStyle}>
                    <div className={styles.titleTwoTextStyle}>诊断：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {diagnosisMessage?.disease}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className={styles.diagnosisContentBottom}>
                <Row>
                  <Col span={24} className={styles.TextStyle}>
                    <div className={styles.titleTwoTextStyle}>意见：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {diagnosisMessage?.view}
                    </div>
                  </Col>
                </Row>
                <Row style={{ paddingTop: 25 }}>
                  <Col span={13} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>医生签字：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                    </div>
                  </Col>
                  <Col span={11} className={styles.TextStyle}>
                    <div className={styles.titleTwoTextStyle}>盖章：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div className={styles.recipeContent} style={{ marginTop: 12, padding: '0 15px' }}>
              <Row gutter={10} className={styles.TextStyleLine}>
                <Col span={12} className={styles.TextStyle}>
                  <div
                    className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                  >
                    {changeData?.show ? changeData?.content : ''}
                  </div>
                </Col>
                {changeData?.printTime && (
                  <Col span={12} className={styles.TextStyle}>
                    <div className={styles.titleFourTextStyle}>打印时间：</div>
                    <div
                      className={`${styles.valueTextStyle} ${styles.valueTextStyleBorderNone}`}
                    >
                      {diagnosisMessage?.printTime}
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}
